import { render, staticRenderFns } from "./RadarInfoTabs.vue?vue&type=template&id=6bc600b0"
import script from "./RadarInfoTabs.vue?vue&type=script&lang=ts"
export * from "./RadarInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports